// extracted by mini-css-extract-plugin
export default {"period_gridheight":"TransactionPeriod_period_gridheight__RifGb","checkbox":"TransactionPeriod_checkbox__aZxJY"};